import { ListingTag } from '__generated__/athena/graphql';
import type { PropertyDetailsFragment } from '__generated__/athena/graphql';

type BuyDirectEligibilityInput = Pick<PropertyDetailsFragment, 'listingTags'>;

export const isBuyDirectEligible = (property: BuyDirectEligibilityInput): boolean => {
  return property.listingTags?.includes(ListingTag.BUY_DIRECT_ELIGIBLE) ?? false;
};
